import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Button } from "nzk-react-components"
import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  min-height: 40vh;
  z-index: 1;
  margin: 0 auto 120px auto;
  justify-content: center;

  display: flex;

  .title {
    position: relative;
    max-width: 470px;
  }

  h2 {
    font-size: 2em;
  }

  .content {
    max-width: 480px;
    padding-top: 130px;

    .cta {
      margin-top: 50px;
    }
  }

  .points {
    display: flex;
    flex-direction: column;
    gap: 2em;

    .point {
      display: flex;
      gap: 0.6em;

      h3 {
        margin: 0;
      }

      .point--content {
        white-space: pre-wrap;
      }
      .point--icon {
        display: flex;
        align-items: flex-start;
        font-family: Nunito;
        font-size: 1.6em;
        margin-top: -0.35em;
      }
    }
  }

  .section-artwork {
    position: relative;
    width: 600px;
    height: 600px;
    transform: translateY(80px);

    .will {
      position: absolute;

      .will--inner {
        position: relative;
        width: 300px;
        height: 600px;
      }

      .will-character {
        position: absolute !important;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .will-glow {
        position: absolute !important;
        top: 0%;
        left: 0%;
        width: 100%;
        height: 100%;
        animation: animate-torch 1s linear alternate-reverse infinite;
      }
    }

    .penguin {
      position: absolute;
      top: 200px;
      left: 180px;
      z-index: -1;
    }
  }

  @media screen and (min-width: 1180px) {
    .start-reading-adventure--left-blob {
      > :nth-child(2) {
        // Kid
        bottom: 0%;
      }
    }
  }

  @media screen and (max-width: 1179px) {
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;

    padding: 0 40px;
    margin: 0 auto;
    line-height: 1.4;

    .title {
      position: relative;
      margin: 0 auto;
      font-size: 1em;
      line-height: 1.2;
    }

    .points {
      width: 100%;
    }

    .cta {
      text-align: center;
    }

  }
  
  @keyframes animate-torch {
    from {
      opacity: 0.8;
    }
    to {
      opacity: 1;
    }
  }

`

export const ParentV2_StartReadingAdventure = (props: {
  title: string
  points: {
    title: string
    text: string
  }[]
  cta: {
    label: string
    url: string
  }
}) => {
  return (
    <Wrapper>
      <div className="section-artwork">
        <div className="will">
          <div className="will--inner">
            <StaticImage
              className="will-character"
              placeholder="blurred"
              src="../../../images/parents-v2/Will-torch.png"
              alt=""
              layout="constrained"
              width={400}
              loading="eager"
              objectFit="contain"
            />
            <StaticImage
              className="will-glow"
              placeholder="blurred"
              src="../../../images/parents-v2/Torch-glow.png"
              alt=""
              layout="constrained"
              width={400}
              loading="eager"
              objectFit="contain"
            />
          </div>
        </div>

        <StaticImage
          className="penguin"
          placeholder="blurred"
          src="../../../images/parents-v2/penguin_top_view.png"
          alt=""
          layout="constrained"
          width={350}
          loading="eager"
          objectFit="contain"
        />
      </div>
      <div className="content">
        <div className="title">
          <h2>{props.title}</h2>
        </div>
        <div className="points">
          {props.points.map((point, i) => (
            <div className="point" key={i}>
              <div className="point--icon" style={{ fontWeight: "bolder" }}>
                ✔
              </div>
              <div className="point--content">
                <h3>{point.title}</h3>
                <div>{point.text}</div>
              </div>
            </div>
          ))}
        </div>
        {props.cta && (
          <div className="cta">
            <Link to={props.cta.url}>
              <Button theme="primary" size="small">
                {props.cta.label}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </Wrapper>
  )
}
